// extracted by mini-css-extract-plugin
export default {"tableWrap":"IssueTable_tableWrap__C0-xq","table":"IssueTable_table__Ufb49","bold":"IssueTable_bold__RUag-","ticketId":"IssueTable_ticketId__btprL","amber":"IssueTable_amber__Gzep9"};